import { Tabs } from "flowbite-react"
import React, { useEffect, useState } from "react"
import CustomSlider from "./custom-slider"

const CommonUseCases = ({ data }) => {
  const [activeTabIndex, setActiveTabIndex] = useState(0)
  const [activeTabDetails, setActiveTabDetails] = useState(null)
  const handleTabChange = index => {
    setActiveTabIndex(index)
  }

  useEffect(() => {
    const tabElement = document.querySelector(
      `.tab-item:nth-child(${activeTabIndex + 1})`,
    )

    // Select the parent element
    const parentElement = tabElement?.parentElement

    if (tabElement && parentElement) {
      const tabRect = tabElement.getBoundingClientRect()
      const parentRect = parentElement.getBoundingClientRect()

      // Calculate left position relative to the parent
      const left = tabRect.left - parentRect.left + parentElement.scrollLeft
      const width = tabRect.width

      setActiveTabDetails({ left, width })
    }
  }, [activeTabIndex])

  return (
    <section
      id="use-case"
      className=" grid  items-center gap-[3rem] md:gap-[5.5rem]  grid-cols-1  pt-16 md:pt-[6.75rem] "
    >
      <div className="flex flex-col gap-4 items-end px-5  xl:px-20 ">
        <h4 className="flex text-gray-500 text-lg lg:text-2xl items-center tracking-tight-2% lg:tracking-tight-4% gap-2">
          {" "}
          <div className="w-[8px]  inline-block rounded-full h-[8px] bg-blue-100"></div>
          {data.section}
        </h4>
        <h3 className="text-gray-100 text-[3.7rem] md:text-5xl lg:text-8xl tracking-[-3.36px] lg:tracking-tight-7%">
          {data.label}
        </h3>
      </div>
      <div className="mt-4 relative">
        <Tabs
          aria-label="Tabs with underline"
          className="justify-around gap-[1px]"
          variant="underline"
          theme={{
            base: "flex flex-col gap-2",
            tablist: {
              base: "flex text-center relative ",
              variant: {
                underline:
                  "-mb-px custom-scrollbar overflow-x-auto border-b border-gray-500 ",
              },
              tabitem: {
                base: "flex text-nowrap  items-center justify-center text-black-300 px-8 md:px-16  py-2 text-lg first:ml-0 focus:outline-none -4  disabled:cursor-not-allowed disabled:text-white-200 ",
                variant: {
                  underline: {
                    base: "rounded-t-lg tab-item",
                    active: {
                      on: "active  font-bold rounded-t-lg transition duration-500  text-blue-100 ",
                      off: "border-b-2 border-transparent text-black-500  hover:border-gray-300 ",
                    },
                  },
                },
              },
            },
            tabitemcontainer: {
              base: "",
              variant: {
                underline: "",
              },
            },
            tabpanel: "bg-white-200 pb-16 md:pb-[6.75rem] pt-8 md:pt-12 ",
          }}
          active={activeTabIndex}
          onActiveTabChange={handleTabChange}
        >
          {data.cases.map((item, index) => (
            <Tabs.Item
              key={index}
              active={activeTabIndex === 0 ? true : false}
              title={
                <div className=" w-full">
                  <span>{item.title}</span>
                  {index === 0 && (
                    <div
                      className="absolute flex tab-slider top-[2.6rem]  transition duration-[2s]"
                      style={{
                        translate: activeTabDetails?.left,
                        width: activeTabDetails?.width,
                      }}
                    ></div>
                  )}
                </div>
              }
            >
              <CustomSlider key={activeTabIndex} data={item} rows={item.rows} />
            </Tabs.Item>
          ))}
        </Tabs>
      </div>
    </section>
  )
}

export default CommonUseCases
